export default {
  "nav.home": "Hjem",
  "nav.guide": "Købsguide",
  "nav.explore": "Køb nu",

  "hero.badge": "Uafhængig ressourcehub",
  "hero.title": "AllChinaBuy Spreadsheet",
  "hero.subtitle": "Find produkter, sælgere og købsressourcer",
  "hero.description": "Opdag nyttige AllChinaBuy-produktressourcer, sælgeroplysninger, QC-guides, forsendelsestips, lageroplysninger og købsguider — samlet i én enkel ressourcehub.",
  "hero.cta.primary": "allchinabuy spreadsheet",
  "hero.cta.secondary": "Køb nu",

  "dropdown.title": "Gennemse en kategori",
  "dropdown.placeholder": "Vælg en kategori…",

  "cat.shoes": "Sko",
  "cat.hoodies": "Hættetrøjer/Sweatshirts",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Jakker",
  "cat.pants": "Bukser/Shorts",
  "cat.headwear": "Hovedbeklædning",
  "cat.sets": "Sæt",
  "cat.underwear": "Undertøj",
  "cat.jersey": "Trøjer",
  "cat.accessories": "Tilbehør",
  "cat.bags": "Tasker",
  "cat.belts": "Bælter",
  "cat.perfumes": "Parfumer",
  "cat.other": "Andre ting",

  "categories.title": "Populære regnearkskategorier",
  "categories.subtitle": "Gå direkte til den produktkategori, du har brug for.",

  "intro.title": "Hvad er AllChinaBuy Spreadsheet?",
  "intro.p1": "AllChinaBuy Spreadsheet er en håndorganiseret samling af links, der hjælper dig med at gennemse AllChinaBuy-produkter hurtigere. I stedet for at skrive de samme søgninger igen og igen, samler regnearket nyttige kategorier — tøj, sko, tasker, tilbehør og mere — så du kan hoppe direkte til den ønskede sektion.",
  "intro.p2": "Fordi AllChinaBuys katalog er stort og hele tiden ændrer sig, sparer et velholdt regneark reel tid. Det samler produktkategorier, sælgersider og købsguider ét sted, hvilket er særligt nyttigt, når du sammenligner styles eller forbereder et nyt indkøb.",
  "intro.p3": "Denne hub er en uafhængig ressource og drives ikke af AllChinaBuy. Tjek altid produktdetaljer, sælgerbedømmelser og forsendelsesmuligheder på den officielle platform, før du bestiller.",

  "features.title": "Hvad du finder indeni",
  "features.t1": "Produktkategorier",
  "features.d1": "Hurtige links til tøj, fodtøj, tasker, tilbehør og andre populære sektioner, så du kan begynde at browse med ét klik.",
  "features.t2": "Produkt- og sælgerressourcer",
  "features.d2": "Henvisninger til de produkt- og sælgersider, der betyder mest, når du undersøger et nyt køb.",
  "features.t3": "QC- og forsendelsestips",
  "features.d3": "Praktisk vejledning om kvalitetskontrol, lagervalg og forsendelsesmuligheder, så du kan planlægge klogere.",
  "features.t4": "Købsguider",
  "features.d4": "Klare, begyndervenlige forklaringer af, hvordan AllChinaBuy fungerer, fra søgning til betaling.",

  "faq.title": "Ofte stillede spørgsmål",
  "faq.q1": "Hvad er AllChinaBuy?",
  "faq.a1": "AllChinaBuy er en international shopping- og videresendelsesplatform, der hjælper købere med at købe varer fra kinesiske sælgere og få dem sendt til hele verden. Den tilbyder produktsøgning, lageropbevaring, kvalitetskontrolbilleder og flere forsendelsesmetoder.",
  "faq.q2": "Hvad er AllChinaBuy Spreadsheet?",
  "faq.a2": "Det er en kurateret liste over AllChinaBuy-kategori- og produktlinks, organiseret så du kan nå sko, hættetrøjer, tasker og andre kategorier direkte uden at søge gentagne gange.",
  "faq.q3": "Er AllChinaBuy Spreadsheet gratis?",
  "faq.a3": "Ja. Denne ressourcehub linker til offentligt tilgængelige kategorisider og opkræver ikke noget for browsing.",
  "faq.q4": "Hvordan bruger jeg kategorilinkene?",
  "faq.a4": "Åbn rullemenuen eller tryk på et kategorikort på denne side, så føres du direkte til den matchende AllChinaBuy-sektion på hovedwebsitet.",
  "faq.q5": "Er AllChinaBuy sikkert at bruge?",
  "faq.a5": "AllChinaBuy er en velkendt platform, men som ved ethvert grænseoverskridende køb bør du altid verificere sælgere, læse varebeskrivelser omhyggeligt og gennemgå forsendelses- og refusionspolitikker, før du betaler.",
  "faq.q6": "Sælger eller sender dette website produkter?",
  "faq.a6": "Nej. Dette website er kun en uafhængig informationshub. Alle køb gennemføres på den officielle platform, som det linker til.",

  "articleCard.label": "Seneste guide",
  "articleCard.title": "AllChinaBuy Spreadsheet: Den komplette begynderguide",
  "articleCard.excerpt": "Lær hvad AllChinaBuy Spreadsheet er, hvordan du bruger det til at finde produkter og sælgere, og trinene til at sende din første ordre med ro i sindet.",
  "articleCard.read": "Læs guiden",

  "articles.title": "Vigtige guides",
  "articles.subtitle": "Dybtgående og originale guides til at handle på AllChinaBuy med ro i sindet.",
  "articles.read": "Læs guiden",
  "articles.related": "Fortsæt med at læse",

  "cta.title": "Klar til at gå i gang?",
  "cta.description": "Åbn det fulde AllChinaBuy Spreadsheet på hovedwebsitet, og find dit næste produkt på få sekunder.",
  "cta.primary": "Besøg hovedwebsitet",
  "cta.secondary": "allchinabuy spreadsheet",

  "footer.disclaimer": "Dette website er en uafhængig informationsressource og er ikke tilknyttet AllChinaBuy. Oplysninger om produkter, sælgere, forsendelse og betaling kan ændre sig når som helst — verificer altid aktuelle detaljer på den officielle platform, før du køber.",
  "footer.rights": "Alle rettigheder forbeholdes.",

  "lang.label": "Sprog",

  "article.title": "AllChinaBuy Spreadsheet: Den komplette begynderguide",
  "article.updated": "Sidst opdateret: august 2026",
  "article.lead": "AllChinaBuy Spreadsheet er en af de enkleste måder at gennemse produkter, sammenligne sælgere og planlægge din forsendelse på AllChinaBuy. I denne guide forklarer vi, hvad regnearket er, hvad det indeholder, og hvordan du bruger det til at handle med større tryghed.",

  "article.h2.1": "Hvad er AllChinaBuy Spreadsheet?",
  "article.p.1": "AllChinaBuy Spreadsheet er en kurateret samling af links, der organiserer AllChinaBuys kategorier i én enkel, overskuelig liste. I stedet for at huske lange søge-URL'er eller skrive de samme forespørgsler igen, åbner du regnearket og hopper direkte til sko, hættetrøjer, t-shirts, tasker, bælter eller en hvilken som helst anden sektion, du har brug for.",
  "article.p.2": "Det fungerer som et genvejsregister. Hver række peger på en aktiv AllChinaBuy-kategori- eller søgeside, så regnearket forbliver nyttigt, så længe platformens URL'er er aktive.",

  "article.h2.2": "Hvorfor bruge et regneark til AllChinaBuy?",
  "article.p.3": "AllChinaBuys katalog er stort, og det kan føles overvældende at gennemse det uden retning. Et regneark hjælper på tre måder. For det første sparer det tid ved at samle kategorier i én visning. For det andet mindsker det fejl, fordi du er mindre tilbøjelig til at lande på den forkerte produkttype. For det tredje gør det gentagne køb lettere — du kan vende tilbage til de samme sektioner, når du forbereder et nyt indkøb.",
  "article.p.4": "Det er især nyttigt for nye købere, der stadig lærer, hvordan platformens søgning og kategorier er opbygget.",

  "article.h2.3": "Hvilke kategorier er inkluderet?",
  "article.p.5": "Regnearket dækker de mest populære AllChinaBuy-kategorier, herunder sko, hættetrøjer og sweatshirts, t-shirts, jakker, bukser og shorts, hovedbeklædning, matchende sæt, undertøj, trøjer, tilbehør, tasker, bælter og parfumer. En opsamlende 'andre ting'-kategori er også inkluderet til alt, der ikke passer pænt andre steder.",
  "article.p.6": "Hver kategori linker til sin matchende sektion på hovedwebsitet, så du kan åbne præcis det, du har brug for, uden ekstra søgning.",

  "article.h2.4": "Sådan bruger du regnearket trin for trin",
  "article.p.7": "Start med at beslutte, hvad du vil købe. Åbn derefter den kategori, der matcher din vare — for eksempel 'Sko' til sneakers eller 'Tasker' til rygsække. Gennemse resultaterne, åbn et produkt du kan lide, og læs sælgeroplysninger og varebeskrivelse, før du lægger noget i kurven.",
  "article.p.8": "Når du er klar, vælger du dit lager og din forsendelsesmetode, gennemgår kvalitetskontrolmulighederne og gennemfører betalingen på den officielle platform.",

  "article.h2.5": "Tips til sikrere køb",
  "article.p.9": "Tjek altid en sælgers bedømmelse og feedback, før du køber. Læs produktbeskrivelser og størrelsesguides omhyggeligt, især for tøj. Brug kvalitetskontrol-fototjenesten, når den er tilgængelig, så du kan se varen, før den sendes. Hold endelig øje med forsendelsesomkostninger og leveringstider, da de varierer efter metode og destination.",

  "article.faq.q1": "Er AllChinaBuy Spreadsheet officiel?",
  "article.faq.a1": "Nej. Det er en uafhængig ressource, der linker til offentligt tilgængelige AllChinaBuy-sider og ikke drives af AllChinaBuy.",
  "article.faq.q2": "Koster linkene i regnearket noget?",
  "article.faq.a2": "Nej. Browsing af de linkede kategorier er gratis; du betaler kun, hvis du vælger at købe et produkt på den officielle platform.",
  "article.faq.q3": "Hvor ofte opdateres regnearket?",
  "article.faq.a3": "Kategorilinkene kontrolleres jævnligt for at holde dem fungerende. Produkttilgængelighed og priser ændrer sig på selve platformen, så verificer altid aktuelle detaljer der.",
  "article.faq.q4": "Kan jeg anmode om en ny kategori?",
  "article.faq.a4": "Listen dækker de mest populære sektioner. Hvis en kategori mangler, er 'Andre ting'-sektionen et godt sted at kigge.",

  "article.back": "Tilbage til hjem",
  "article.cta.title": "Åbn AllChinaBuy Spreadsheet",
  "article.cta.text": "Gennemse alle produktkategorier og start din næste ordre på hovedwebsitet.",
  "article.cta.button": "Besøg hovedwebsitet",
};